import { Injectable } from "@angular/core";
import { RestService } from "../../../core/core/rest.service";
import { User } from "../users.model";

@Injectable()
export class UsersListRest {
    constructor(private http: RestService) { }

    public getUsers() {
        return this.http.get<User[]>('api/users');
    }

    public deleteUser(userId: number) {
        return this.http.post(`api/user/delete/${userId}`, {});
    }

}